import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import users from 'modules/core/store/collections/users'

import CollectionsBootstrap from 'modules/locations/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => users.current.policy.can('locations.locationManage')}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
